/**
 * Created by meirr on 1/23/17.
 */
define(function (require) {

    var BASE = require('web-agent-adapters/BaseAdapter');
    var MessagingAgentListAdapter  = BASE.extend(function (options) {});

    MessagingAgentListAdapter.prototype.searchAgents = function (request) {

        var successHandler = request.success;
        request.success = function(res) {
            var successHandlerData = successHandlerCreator(res);
            if (successHandlerData !== null) {
                    successHandler(successHandlerData);
            } else {
                request.error({
                    error: "Fail to load Messaging Agents data"
                });
            }
        };
        // If SearchAgents success but AgentActivity or MessagingConversation fails, the recipe return with the data of the succeeded calls but with error status code 500.
        // In this case we like to show the data we have in the table.
        request.error = request.success;

        return this.service.searchAgents(request);
    };

    function successHandlerCreator(res){
        if(res && res.body && res.body.SearchAgents && res.body.SearchAgents.body && res.body.SearchAgents.body.agentStatusRecords && res.body.SearchAgents.body._metadata) {
            var agentActivityArray = createAgentActivityArray(res.body);
            var messagingConversationArray = createMessagingConversationArray(res.body);
            return {
                count: res.body.SearchAgents.body._metadata.count,
                data: mapRecordsData(res.body, agentActivityArray, messagingConversationArray)
            };
        } else {
            return null;
        }
    }
    /**
     * Create an array of the Agent Active data when agent ID is the key
     * @param res
     */
    function createAgentActivityArray(res){
        var agentActivityArray=[];
        // set agentActivity array
        if (res && res.AgentActivity && res.AgentActivity.body && res.AgentActivity.body.agentsMetrics && res.AgentActivity.body.agentsMetrics.metricsPerAgent) {
            agentActivityArray = res.AgentActivity.body.agentsMetrics.metricsPerAgent;
        }
        return agentActivityArray;
    }

    /**
     * Create an array of the Messaging Conversation data when agent ID is the key
     * @param res
     */
    function createMessagingConversationArray(res){
        var messagingConversationArray;
        // set messagingConversation array
        if (res && res.MessagingConversation && res.MessagingConversation.body){
            if (res.MessagingConversation.body.agentsMetrics && res.MessagingConversation.body.agentsMetrics.metricsPerAgent) {
                messagingConversationArray = res.MessagingConversation.body.agentsMetrics.metricsPerAgent;
            } else {// if the message is OK, but no data on agents, we need to show 0 as the results
                messagingConversationArray = [];
            }
        }
        return messagingConversationArray;
    }

    /**
     * Calculate and return the online rate of agent by getting the total login time and the total online time
     * @param agentActivityArray
     * @param agentId
     * @returns {*}
     */
    function getOnlineRateById(agentActivityArray, agentId){
        var onlineRate = null;
        if (agentActivityArray && agentActivityArray[agentId]) {
            var loginTotal;
            var onlineTotal;
            for (var key in agentActivityArray[agentId]) {
                switch (agentActivityArray[agentId][key].id) {
                    case 2:
                        onlineTotal = agentActivityArray[agentId][key].value.total;
                        break;
                    case -1:
                        loginTotal = agentActivityArray[agentId][key].value.total;
                        break;
                }
            }
            if (_.isNumber(loginTotal) && _.isNumber(onlineTotal) && loginTotal > 0){
                onlineRate = Math.floor((onlineTotal / loginTotal) * 100);
            }
        }
        return onlineRate;
    }

    /**
     * Return the closed Conversations. If the API fails, return null. if not and no data for agent return 0
     * @param messagingConversationArray
     * @param agentId
     * @returns {*}
     */
    function getClosedConversationsById(messagingConversationArray, agentId){
        if (_.isUndefined(messagingConversationArray)){
            return null;
        }
        return messagingConversationArray[agentId] ? messagingConversationArray[agentId].totalResolvedConversations : 0;
    }

    function mapRecordsData(res, agentActivityArray, messagingConversationArray) {
        var data = [];
        (res.SearchAgents.body.agentStatusRecords || []).forEach(function(record){
            data.push({
                agentGroupId: record.agentGroupId,
                agentGroupName: record.agentGroupName,
                agentId: record.agentId,
                agentName: record.agentName,
                agentPictureURL: record.agentPictureURL,
                configuredMaxSlots: record.configuredMaxSlots,
                currentStatus: record.currentStatus,
                currentStatusReason: record.currentStatusReason,
                currentStatusReasonDuration: record.currentStatusReasonDuration,
                currentStatusDuration: record.currentStatusDuration,
                load: record.load,
                openAssignedConversations: record.openAssignedConversations,
                activeConversations: record.intenseConversations,
                agentSkills: record.agentSkills,
                onlineRate: getOnlineRateById(agentActivityArray, record.agentId),
                closedConversations: getClosedConversationsById(messagingConversationArray, record.agentId)
            });
        });
        return data;
    }

    return MessagingAgentListAdapter;

});
